import {getAnonymizedUserId} from "@/utils/firebase";
import {User} from "firebase/auth";
import {useEffect} from "react";
import * as Sentry from "@sentry/react";

/**
 * Hook to set the Sentry user based on the Firebase Auth user.
 * @param user The user object from Firebase Auth.
 */
export const useSetSentryUser = (user: User | null | undefined) => {
  useEffect(() => {
    if (user) {
      // Set the user id in Sentry to track errors.
      // The user id is the first half of the uid to avoid exposing the full uid.
      Sentry.setUser({id: getAnonymizedUserId(user.uid)});
    } else {
      // If the user is not logged in, set the user to null.
      Sentry.setUser(null);
    }
  }, [user]);
};
